import styled from 'styled-components'

import { Close } from '../../../components/Icons/components'
import withCondition from '../../../components/withCondition'
import { grayLight, media } from '../../../utils/style-utils'

export const StyledCloseIcon = withCondition(styled(Close).withConfig({
  shouldForwardProp: (prop) => !prop.includes('isActive'),
})`
  position: absolute;
  height: 2.5em;
  top: 50%;
  right: 1rem;
  transform: translateY(-50%);
  fill: ${grayLight};

  ${media.md`
    height: 2rem;
  `}
`)
